import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=40cf60d9"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40cf60d9')) {
      api.createRecord('40cf60d9', component.options)
    } else {
      api.reload('40cf60d9', component.options)
    }
    module.hot.accept("./BarChart.vue?vue&type=template&id=40cf60d9", function () {
      api.rerender('40cf60d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/merbershipSystems/dashboard/components/BarChart.vue"
export default component.exports